var VM = function () {
    var self = this;

    self.content = ko.observable("");
    self.secondsIncluded = ko.observable(false);
    self.secondsIncluded.subscribe(function () {
        self.cronExp.valueHasMutated();
    });
    self.nextScheduledDates = ko.observable(5);
    self.nextScheduledDates.subscribe(function () {
        self.cronExp.valueHasMutated();
    });
    self.nextScheduledDatesArr = ko.observableArray([5, 10, 25, 50, 100]);
    self.cronExp = ko.observable("");
    self.cronLength = ko.computed(function() {
        return self.cronExp().split(" ").length;
    });
    self.error = ko.observable(null);
    self.showResult = ko.observable(true);
    self.humanReadableExpression = ko.observable(null);
    self.shareLink = ko.observable(null);

    self.cronExp.subscribe(function (newValue) {

        // change hash based on newValue
        var newHash = newValue.replaceAll(' ', '_').trim();
        while( newHash[newHash.length - 1] === "_" ) {
            newHash = newHash.slice(0, -1);
        }
        history.replaceState(undefined, undefined, "#" + newHash);

        if(newValue !== "") {
            if((self.cronLength() === 5 && self.secondsIncluded() === false) || (self.cronLength() === 6 && self.secondsIncluded() === true)) {
                try {
                    const regex = /\/-\d/g;
                    if (!newValue.match(regex)) {
                        var datesArr = [];
                        var description = parse(newValue, {hasSeconds: self.secondsIncluded()});
                        var parseCron = later.parse.cron(newValue, self.secondsIncluded());
                        var dates = later.schedule(parseCron).next(self.nextScheduledDates());
                        self.humanReadableExpression("\"" + cronstrue.toString(newValue) + "\"");
                        self.shareLink(window.location.href);
                        self.content(dates.join("\r\n"));
                        self.showResult(true);
                        self.error(null);
                    } else {
                        throw Error("Invalid cron expression syntax. Negative value numbers are not allowed.");
                    }
                } catch(error) {
                    self.showResult(false);
                    self.shareLink(null);
                    self.content("");
                    self.error(error.message || "Please check the cron expression syntax.");
                }
            } else {
                self.showResult(false);
                self.shareLink(null);
                self.error("Please check the cron expression syntax.");
            }
        } else {
            self.showResult(false);
            self.shareLink(null);
            self.error(null);
        }
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });

    self.init = function() {
        if(window.location.hash) {
            var hash = window.location.hash.substring(1),
                hashLength = hash.split('_').length;
            hash = hash.replaceAll('_', ' ');
            self.cronExp(hash);
            if(hashLength === 6) {
                self.secondsIncluded(true);
            }
        } else {
            self.cronExp("* * * * *");
        }
    }

    // Share popover
    const sharePopover = new bootstrap.Popover('#sharebutton', {
        trigger: 'manual',
        placement: 'bottom',
        container: '.share-button-wrapper',
        html: true,
        sanitize: false,
        content: `
            <div class="content-share">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" id="popover-share-input" data-bind="textInput: self.shareLink()" readonly />
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" id="popover-share-button"><i class="fal fa-copy me-1"></i>Copy</button>
                    </div>
                </div>
            </div>`
    });

    // Share stack trace button
    document.querySelector('#sharebutton').addEventListener('click', function () {
        if (self.shareLink() !== null) {
            sharePopover.show();
        }
    });

    document.querySelector('#sharebutton').addEventListener('shown.bs.popover', function () {
        const inputElement = document.querySelector('#popover-share-input');
        inputElement.value = window.location.href;
    });

    // Share button copy
    var shareCron = new ClipboardJS('#popover-share-button', {
        text: function() {
            return document.querySelector('#popover-share-input').value;
        }
    });
    shareCron.on('success', function (e) {
        e.clearSelection();
        document.querySelector('#popover-share-button').innerHTML = '<i class="fas fa-copy me-1"></i>Copied!';
        setTimeout(function () {
            sharePopover.hide();
        }, 1000);
    });

    // Close popover when click outside
    document.body.addEventListener("click", function(e) {
        document.querySelectorAll('.share-button-wrapper .popover').forEach(function(popover) {
            if (!(e.target.id === 'sharebutton' || e.target.parentElement.id === 'sharebutton') && !e.target.closest('.popover')) {
                sharePopover.hide();
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);
    vm.init();

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
});